import "./main.css";

export default function Main() {
  return (
    <div className="start-page">
      <header className="start-header">
        <span className="start-brand">podvaltech</span>
      </header>
      <main className="start-main">
        <h1 className="start-title" aria-label="А ты готов к заклу?">
          А ТЫ ГОТОВ
          <br />К ЗАКЛУ?
        </h1>
        <div className="start-bottom">
          <p>Олимпиадные задания по технологии</p>
          <a className="start-action" href="#tests">
            К тестам →
          </a>
        </div>
      </main>
    </div>
  );
}
